import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmailsApi } from './types';

export const emails: TEmailsApi = {
	getEmailsList: (payload) =>
		http.post(endpoint.emails.LIST, payload).then((response) => response.data),
	getEmailsTypes: () => http.get(endpoint.emails.TYPES).then((response) => response.data),
};
